import { SegmentsMonthlyVisitsGraphWidget } from "./SegmentsMonthlyVisitsGraphWidget";
import type { DashboardMetric } from "./type";

export class SegmentsBounceRateGraphWidget extends SegmentsMonthlyVisitsGraphWidget {
    metric: DashboardMetric;

    constructor() {
        super();
        this.metric = "BounceRate";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return "SegmentsBounceRateGraph";
    }

    public getGraphData(transformedData) {
        return super.getGraphData(transformedData, this.metric);
    }
}

SegmentsBounceRateGraphWidget.register();
